exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dataLabelManagement .formHeight[data-v-c9c99c26]{height:45px}#dataLabelManagement .titleBox[data-v-c9c99c26]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}#dataLabelManagement .divider[data-v-c9c99c26]{height:1px;border-bottom:1px solid #dcdcdc;-webkit-box-flex:1;-ms-flex:1;flex:1}", ""]);

// exports
